import { reloadApi } from "../api";
import { AuthApi } from "../requests";
import { store } from "../store";
import { store as uiStore } from "../store/ui";
import { updateLastPage, adResetStatus } from "../actions/adLogin";
import { getMe } from "./getMe";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function login(username: string, psw: string): Promise<boolean> {
    const auth = new AuthApi({
        username,
        psw,
        basePath: uiStore.apiPath
    });

    auth.authLoginCreate(username, psw, async (response) => {
        if (response instanceof Error || response.message.error) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response.message);
            } else {
                store.doNotice(lang[response.message.error]);
            }

            return false;
        }

        uiStore.setLoaded(false);

        store.doNotice(lang[response.message.success], true);

        await updateUserAccess(true);

        return true;
    });

    return false;
}

function loginAd(token: string): void {
    const auth = new AuthApi({
        basePath: uiStore.apiPath
    });

    auth.authLoginAdCreate(token, async (response) => {
        if (response instanceof Error || response.message.error) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response.message);
            } else {
                store.doNotice(lang[response.message.error]);

                adResetStatus();
            }
        } else if (response.message.success) {
            localStorage.removeItem(`${HelperSrc.LABEL}_ad_working_status`);
            uiStore.setLoaded(false);
            store.setIsAD(true);

            return updateUserAccess(true);
        }
    });
}

async function updateUserAccess(isLogin = false): Promise<void> {
    if ((store && store.user.id) || isLogin) {
        try {
            reloadApi();

            await getMe()
                .then((result: HelperSrc.UserStore | null) => {
                    if (result) {
                        uiStore.setUserid(result.id || -1);
                    }
                })
                .catch();
        } catch (e) {
            if (e instanceof Error) {
                HelperSrc.writeLog("updateUserAccess()", e.message);
            }

            if (location.pathname !== "ad/login") {
                updateLastPage();
            }
        }
    }

    uiStore.setLoaded(true);
}

export { login, updateUserAccess, loginAd };
